/**
 * @flow
 * @relayHash 2d70b91fea0dbdc3f86173bce6b69aba
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteRunInput = {|
  id: string
|};
export type DeleteRunMutationVariables = {|
  input: DeleteRunInput
|};
export type DeleteRunMutationResponse = {|
  +deleteRun: {|
    +deletedId: string
  |}
|};
export type DeleteRunMutation = {|
  variables: DeleteRunMutationVariables,
  response: DeleteRunMutationResponse,
|};
*/


/*
mutation DeleteRunMutation(
  $input: DeleteRunInput!
) {
  deleteRun(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteRunInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteRun",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteRunPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteRunMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteRunMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteRunMutation",
    "id": null,
    "text": "mutation DeleteRunMutation(\n  $input: DeleteRunInput!\n) {\n  deleteRun(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b9ad8e96b502064bdfb188c6556fae4';
module.exports = node;
